// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__UO9WW","list":"BalanceDue_list__2Qhpx","listRow":"BalanceDue_listRow__ruTpV","total":"BalanceDue_total__2wzqf"};